import { forwardRef } from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";

import type {
  TSheetTriggerElement,
  TSheetTriggerProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";

export const SheetTrigger = forwardRef<TSheetTriggerElement, TSheetTriggerProps>(
  (props, ref) => (
    <SheetPrimitive.Trigger
      data-component="SheetTrigger"
      ref={ref}
      {...props}
    />
  ),
);

SheetTrigger.displayName = SheetPrimitive.Trigger.displayName;
